import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import { GridRowOrderChangeParams } from '@mui/x-data-grid-pro';
import { ESectionOfferType } from 'constants/enums';
import { useSectionsState } from 'state/hooks/sections.hook';

import { Section } from '../../../../common/contracts';
import DataTable from '../../../DataTable/DataTable';
import { SectionsItem } from '../storeTheme.types';

interface SectionsTableProps {
  sections: SectionsItem[];
  setSections: (sections: SectionsItem[]) => void;
  setFieldValue: any;
}

export const StoreThemeSectionsTable: React.FC<SectionsTableProps> = ({
  sections,
  setSections,
  setFieldValue
}) => {
  const { editedSectionId, setEditedSectionId, setCurrentSection } =
    useSectionsState();

  const editSection = (row: Section) => {
    setCurrentSection({ ...row });
    setEditedSectionId(row.publisherSectionId);
  };

  const removeSection = (id: string) => {
    // here
    if (id === editedSectionId) {
      setEditedSectionId('');
      setCurrentSection(null);
    }

    const existingSection = sections.find(
      (section: SectionsItem) =>
        section.publisherSectionId === id && section.sectionId
    );

    const updatedSectionsList = existingSection
      ? sections.map((section) => {
          if (section.publisherSectionId === id) {
            return { ...section, toBeDeleted: true };
          }
          return section;
        })
      : sections.filter((section) => section.publisherSectionId !== id);
    setSections(updatedSectionsList);
    if (
      !existingSection?.offerType ||
      existingSection?.offerType === ESectionOfferType.BUNDLE
    ) {
      setFieldValue('bundleSections', updatedSectionsList);
    } else {
      setFieldValue('promotionSections', updatedSectionsList);
    }
  };

  const sectionsData = sections.filter((section) => !section.toBeDeleted);

  const handleSectionsOrderChange = (targetIndex: number, oldIndex: number) => {
    const sectionsList = [...sectionsData];
    const row = sectionsList.splice(oldIndex, 1)[0];
    sectionsList.splice(targetIndex, 0, row);
    const newSectionsList = sectionsList.map((item) => ({
      ...item,
      toBeEdited: true
    }));
    setSections(newSectionsList);
    const restSections = sections.filter(
      (section) => !sectionsList.includes(section)
    );
    const updatedSectionsData =
      restSections.length > 0
        ? [...newSectionsList, ...restSections]
        : newSectionsList;
    if (
      !updatedSectionsData[0]?.offerType ||
      updatedSectionsData[0]?.offerType === ESectionOfferType.BUNDLE
    ) {
      setFieldValue('bundleSections', updatedSectionsData);
    } else {
      setFieldValue('promotionSections', updatedSectionsData);
    }
  };

  return (
    <DataTable
      className="[&_.MuiDataGrid-root]:border-0"
      columns={[
        {
          field: 'publisherSectionId',
          headerName: 'ID',
          flex: 1
        },
        {
          field: 'image',
          headerName: '',
          flex: 1,
          renderCell: (params: any) => {
            return params.row.image ? (
              <img
                style={{
                  maxHeight: '50%',
                  objectFit: 'contain'
                }}
                src={params.row.image}
                alt="productImage"
              />
            ) : (
              ''
            );
          }
        },
        {
          field: 'name',
          headerName: 'Name',
          flex: 1
        },
        {
          field: 'remove',
          headerName: 'Remove',
          renderCell: (params) => (
            <IconButton onClick={() => removeSection(params.row._id)}>
              <DeleteIcon />
            </IconButton>
          ),
          flex: 1
        },
        {
          field: 'edit',
          headerName: 'Edit',
          renderCell: (params) => (
            <IconButton onClick={() => editSection(params.row)}>
              <EditIcon />
            </IconButton>
          ),
          flex: 1
        }
      ]}
      rows={sectionsData}
      loading={false}
      rowReordering={true}
      onRowOrderChange={(params: GridRowOrderChangeParams) =>
        handleSectionsOrderChange(params.oldIndex, params.targetIndex)
      }
    />
  );
};
